import { ConfirmationModalProps } from "../../../utils/interfaces";

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    show,
    onClose,
    onConfirm,
    title,
    body,
    maxHeight="20vh",
    maxWidth="30vw",
    closeText="Cancel"
}) => {
    return (
        <>
            {show && (
                <div
                    className="modal-overlay"
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        zIndex: 999,
                    }}
                ></div>
            )}

            <div
                className="modal card fadeIn"
                style={{
                    display: show ? "block" : "none",
                    position: "absolute",
                    maxWidth: maxWidth,
                    maxHeight: maxHeight,
                    top: "20%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 1000,
                    border: "1px solid #dee2e6",
                    borderRadius: "14px",
                }}
            >
                <div className="modal-header">
                    <h5 className="modal-title">{title}</h5>
                </div>
                <div className="modal-body"  style={{backgroundColor: onConfirm ? 'inherit' : '#ebe6e3', maxHeight: '70% !important'}}>
                    {body}
                </div>
                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={onClose}>
                       {closeText}
                    </button>
                    {onConfirm && (
                        <button className="btn btn-primary" onClick={onConfirm}>
                            Confirm
                        </button>
                    )}
                </div>
            </div>
        </>
    );
};
